import { trackSubjectMap, subjectGroups } from '@/mocks/subjectData';

interface Props {
  trackId: string;
  trackName: string;
}

export default function ResultSubjects({ trackId, trackName }: Props) {
  const map = trackSubjectMap[trackId];
  if (!map) return null;

  const allSubjects = subjectGroups.flatMap((g) => g.subjects);
  const lookup = (name: string) => allSubjects.find((s) => s.name === name);

  const sections = [
    {
      title: '필수과목',
      note: '진학에 꼭 필요한 과목',
      items: map.core,
      badge: 'bg-primary-100 text-primary-700',
      dot: 'bg-primary-500',
    },
    {
      title: '권장과목',
      note: '전공 이해에 도움이 되는 과목',
      items: map.recommended,
      badge: 'bg-accent-100 text-accent-700',
      dot: 'bg-accent-500',
    },
    {
      title: '진로·심화과목',
      note: '전공 심화와 진로 탐색 과목',
      items: map.career,
      badge: 'bg-secondary-100 text-secondary-700',
      dot: 'bg-secondary-500',
    },
  ];

  return (
    <div className="bg-background-50 border border-background-200 rounded-xl p-5 mb-4">
      <h2 className="font-semibold text-foreground-950 mb-1 flex items-center gap-2">
        <i className="ri-book-open-line text-primary-500"></i>
        나에게 맞는 필수·권장 과목
      </h2>
      <p className="text-xs text-foreground-500 mb-4">
        <span className="font-medium text-foreground-700">{trackName}</span> 진학에 필요한 과목을 진로에 맞게 자동으로 정리했어요.
      </p>

      <div className="space-y-4">
        {sections.map((section) => (
          <div key={section.title}>
            <div className="flex items-center gap-2 mb-2">
              <span className={`w-2 h-2 rounded-full ${section.dot}`}></span>
              <span className="text-sm font-semibold text-foreground-900">{section.title}</span>
              <span className="text-xs text-foreground-400">{section.note}</span>
            </div>
            <div className="flex flex-wrap gap-2">
              {section.items.map((name) => {
                const info = lookup(name);
                return (
                  <div
                    key={name}
                    className="border border-background-200 bg-background-50 rounded-lg px-3 py-2 max-w-full"
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{name}</span>
                      <span className={`text-[10px] px-1.5 py-0.5 rounded-full ${section.badge}`}>
                        {section.title === '필수과목' ? '필수' : section.title === '권장과목' ? '권장' : '심화'}
                      </span>
                    </div>
                    {info && (
                      <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{info.description}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}